// extracted by mini-css-extract-plugin
export default {"app":"App_app__V+GKd","logoBack":"App_logoBack__862DG"};